<template>
    <el-card class="box-card">
        <div class="query-panel">
            <el-form :inline="false">
                <el-form-item>
                    <el-button size="small" type="primary" @click="showCreateNotice">创建维护公告</el-button>
                </el-form-item>
                <el-form-item>
                    <span style="color: red;">Tip:对应服务器无特定的公告就使用默认公告</span>
                </el-form-item>
            </el-form>
        </div>

        <el-table :data="dataHandled" border>
            <el-table-column prop="memo" width="150px" label="备注"></el-table-column>
            <el-table-column prop="createDate" width="150px" label="创建时间" :formatter="formatterTime"></el-table-column>
            <el-table-column prop="content" label="公告内容">
                <template slot-scope="scope">
                    <span>{{JSON.stringify(scope.row.content).slice(0,50) + (JSON.stringify(scope.row.content).length > 50?"...":"")}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="serverIds" width="150px" label="生效的服务器"></el-table-column>
            <el-table-column label='操作'>
                <template slot-scope="scope">
                    <el-button type="text" @click="editContent(scope.row)">编辑</el-button>
                    <el-button type="text" @click="noticeMaintenanceDelete(scope.row.id)" v-if="scope.row.id !== 1">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
                           :page-size="pageSize"git
                           layout="total, prev, pager, next, jumper" :total="totalRow">
            </el-pagination>
        </div>

        <el-dialog title='编辑' :visible.sync="editContentShow" width="50%" lock-scroll center>
            <div>
                <component-server @gameValue="getGameValue" :serverMode="'mode_game'" v-if="editContentData.id !== 1"></component-server>

                <el-form :inline="true" label-position="left">
                    <el-form-item label="备注:">
                        <el-input v-model="editContentData.memo" placeholder="请输入备注"></el-input>
                    </el-form-item>
                </el-form>

                <el-tabs v-model="editTabsValue" type="card">
                    <el-tab-pane
                        v-for="(item2, index2) in langType"
                        :key="item2.id"
                        :label="item2.label"
                        :name="item2.val"
                    >
                        <span slot="label">{{item2.label}}<el-badge :value="(value == '') ? '!' : ''" v-for="(value, key) in noticeEditContent" :key="key" v-if ="item2.val == key" class="mail-badge"></el-badge></span>

                        <template v-for="(value, key) in noticeEditContent" v-if ="item2.val == key">
                            <el-card>
                                <el-form label-position="left" label-width="60px">
                                    <el-form-item label='内容'>
                                        <el-input v-model="noticeEditContent[key]" type="textarea" :rows="3" placeholder="请输入内容">
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                        </template>

                    </el-tab-pane>
                </el-tabs>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editContentShow = false">取消</el-button>
                <el-button type="primary" @click="noticeMaintenanceEdit">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title='创建' :visible.sync="createNoticeShow" width="50%" lock-scroll center>
            <div>
                <component-server @gameValue="getGameValue" :serverMode="'mode_game'"></component-server>

                <el-form label-position="right" label-width="100px">
                    <el-form-item label="备注:">
                        <el-input v-model="noticeMaintenanceForm.memo" placeholder="请输入备注"></el-input>
                    </el-form-item>
                </el-form>

                <el-tabs v-model="sendTabsValue" type="card">
                    <el-tab-pane
                        v-for="(item2, index2) in langType"
                        :key="item2.id"
                        :label="item2.label"
                        :name="item2.val"
                    >
                        <span slot="label">{{item2.label}}<el-badge :value="(value == '') ? '!' : ''" v-for="(value, key) in noticeSendContent" :key="key" v-if ="item2.val == key" class="mail-badge"></el-badge></span>

                        <template v-for="(value, key) in noticeSendContent" v-if ="item2.val == key">
                            <el-card>
                                <el-form label-position="left" label-width="60px">
                                    <el-form-item label='内容'>
                                        <el-input v-model="noticeSendContent[key]" type="textarea" :rows="3" placeholder="请输入内容">
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                        </template>

                    </el-tab-pane>
                </el-tabs>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="createNoticeShow = false">取消</el-button>
                <el-button type="primary" @click="noticeMaintenanceSend">确定</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
    import noticeMaintenanceApi from '../../service/notice_maintenance_api'
    import confApi from '../../service/conf_api'
    import loginApi from '../../service/login_api'
    import {
        mapState
    } from 'vuex';
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import componentServer from '../../components/component_server'
    import Utils from '../../lib/utils'

    export default {
        name: "maintenance_notice_manager",
        data() {
            return {
                activeName: 'first',
                Utils: Utils,
                content:'',
                editContentShow: false,
                editContentData: {},
                editTabsValue: 'zh-Hans',
                sendTabsValue: 'zh-Hans',
                noticeEditContent: {
                    'zh-Hans': '',
                    'zh-Hant': '',
                    'ja-JP': '',
                    'ko-KR': '',
                    'ru-RU': '',
                    'en-US': '',
                },

                createNoticeShow: false,
                noticeMaintenanceForm: {
                    memo: '',
                    content: {},
                },
                noticeSendContent:  {
                    'zh-Hans': '',
                    'zh-Hant': '',
                    'ja-JP': '',
                    'ko-KR': '',
                    'ru-RU': '',
                    'en-US': '',
                },

                gameServerData: [],

                reloadOtherConfigData: [],

                editorOption: {
                    modules: {
                        toolbar: {
                            container: [
                                // ['blockquote', 'code-block'],// 引用  代码块
                                // [{'direction': 'rtl'}],// 文本方向
                                // ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
                                ['bold', 'underline'], // 加粗 斜体 下划线 删除线
                                // [{ header: 1 }, { header: 2 }], // 1、2 级标题
                                // [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
                                // [{ script: 'sub' }, { script: 'super' }], // 上标/下标
                                // [{ indent: '-1' }, { indent: '+1' }], // 缩进
                                // [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
                                // [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
                                // [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
                                [{ color: ["#ffffff", "#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466", '#ffc437', '#a6bddd'] }], // 字体颜色、字体背景颜色
                                // [{ font: [] }], // 字体种类
                                // [{ align: [] }], // 对齐方式
                                // ['clean'], // 清除文本格式
                                // ['link', 'image', 'video'] // 链接,图片,视频
                                ['link'] // 链接,图片,视频
                            ],
                            handlers: {
                                image: function(value) {
                                    if (value) {
                                        document.querySelector('#upload').click()  // 劫持原来的图片点击按钮事件
                                    } else {
                                        this.quill.format('image', false)
                                    }
                                }
                            }
                        }
                    }
                },
            }
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverGameList: state => state.server.serverGameList,
            }),
        },
        mounted() {
            this.getLangs();
            this.getNoticeMaintenanceData();
            this.getNodeAndLoginData();
        },
        mixins: [paginationController, actionConfirm],
        methods: {
            getGameValue(val) {
                this.gameServerData = [];
                this.serverGameList.forEach(item => {
                    val.forEach(item2 => {
                        if (item.id == item2) {
                            this.gameServerData.push(item.server_number);
                        }
                    })
                })
            },

            // 公告列表
            getNoticeMaintenanceData() {
                noticeMaintenanceApi.noticeMaintenanceList({
                    token: this.token
                }).then(res => {
                    this.rawData = res;
                    this.totalRow = res.length;
                });
            },

            formatterTime(row) {
                var createDate = row.createDate;
                createDate = Utils.formatDate(createDate);
                return createDate;
            },

            editContent(e) {
                this.editContentShow = true;
                this.editContentData = e;
                this.noticeEditContent = JSON.parse(e.contentJson);
            },

            showCreateNotice() {
                this.createNoticeShow = true;
                this.noticeSendContent =  {
                    'zh-Hans': '',
                    'zh-Hant': '',
                    'ja-JP': '',
                    'ko-KR': '',
                    'ru-RU': '',
                    'en-US': '',
                };
                this.noticeMaintenanceForm.memo = '';
                this.noticeMaintenanceForm.content = {};
            },

            // 创建公告
            noticeMaintenanceSend() {
                var data = this.noticeMaintenanceForm;

                data.content = this.noticeSendContent;

                noticeMaintenanceApi.noticeMaintenanceSend({
                    token: this.token,
                    noticeMaintenanceForm: {
                        memo: data.memo,
                        content: data.content,
                        serverIdsList: this.gameServerData
                    },
                }).then(res => {
                    this.reloadAxiosLogin();
                    this.$message({
                        type: 'success',
                        message: '创建成功!'
                    })
                    this.createNoticeShow = false;
                    this.getNoticeMaintenanceData();
                })
            },

            // 删除公告
            noticeMaintenanceDelete(id) {
                noticeMaintenanceApi.noticeMaintenanceDelete({
                    token: this.token,
                    noticeMaintenanceForm: {
                        id: id
                    },
                }).then(res => {
                    this.reloadAxiosLogin();
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                    this.getNoticeMaintenanceData();
                })

            },

            // 编辑公告
            noticeMaintenanceEdit() {
                var data = this.editContentData;

                data.content = this.noticeEditContent;
                if (data.id !== 1) {
                    data.serverIdsList = this.gameServerData;
                }

                noticeMaintenanceApi.noticeMaintenanceEdit({
                    token: this.token,
                    noticeMaintenanceForm: {
                        id: data.id,
                        memo: data.memo,
                        content: data.content,
                        serverIdsList: data.serverIdsList
                    }
                }).then(res => {
                    this.reloadAxiosLogin();
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    })
                    this.editContentShow = false;
                    this.getNoticeMaintenanceData();
                })

            },

            // 获取登录服和战斗服数据
            getNodeAndLoginData() {
                let self = this;
                confApi.getReadData({
                    token: self.token,
                    tableName: 'yunwei_server_config'
                }).then(res => {
                    res.forEach(item => {
                        if (item.server_type == 'login' || item.server_type == 'battleValidate') {
                            self.reloadOtherConfigData.push({
                                port_json: item.port_json,
                                uri: item.server_url,
                                type: item.server_type,
                                server_name: item.server_name,
                                resStatus: 0,
                                msg: '未发送',
                                initPort: item.port_proc,
                            })
                        }
                    })
                })
            },

            // 重载登录服
            reloadAxiosLogin() {
                let self = this;

                self.reloadOtherConfigData.forEach((otherItem,otherIndex) => {
                    let reloadForm= {};
                    if (otherItem.type == 'login') {
                        reloadForm = {
                            loginUri: otherItem.uri,
                            type: otherItem.type,
                            className: 'NoticeMaintenanceConfig'
                        }

                        loginApi.loginReloadConfig({
                            token: self.token,
                            reloadForm: reloadForm
                        }).then(res => {
                            otherItem.resStatus = res.resStatus;
                        })
                    }
                })
            },
        },
        components: {
            componentServer
        }
    }
</script>

<style lang="less">
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 492.5px;
        height: 62px;
        line-height: 62px;
        text-align: center;
    }
    .avatar {
        width: 492.5px;
        height: 62px;
        display: block;
    }

    .avatar-limit {
        color: red;
    }

    /*.el-dialog__body {*/
    /*color: #ffffff;*/
    /*}*/

    /*.ql-editor.ql-blank::before {*/
    /*color: #ffffff;*/
    /*}*/

    .ql-container.ql-snow {
        color: #ffffff !important;
        background-color: #233858 !important;
    }

    .ql-editor.ql-blank::before {
        color: #ffffff !important;
    }
</style>

<style scoped lang="less">
    .notice-tip {
        color: red;
        margin-bottom: 10px;
    }

    .notice-top-tip {
        color: red;
    }

    .editor-quill {
        margin-bottom: 30px;
    }

    .notice-png-list {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/views/maintenance/maintenance_notice_manager.vue